import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {trackEvent} from '../../../utils/tracking.js';
import '@fiverr/globals';
import './style.scss';

class Favorite extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            animation: false
        };

        this.heartIcon = null;

        this.onClick = this.onClick.bind(this);
        this.playAnimation = this.playAnimation.bind(this);
    }

    onClick(e) {
        const { isFavorited, user, toggleCollection, cardType, cardSize, gigId, sellerId } = this.props,
            payload = {
                collection: {
                    type: 'gig',
                    source: 'gig_card',
                    name: 'Gigs I Love'
                },
                user: {
                    id: user.userId
                },
                seller: {
                    id: sellerId
                },
                gig: {
                    id: gigId
                }
            };

        trackEvent(`heart-${!isFavorited ? 'collect' : 'uncollect'}`, cardType, cardSize);
        trackEvent(`collection_items.${!isFavorited ? 'create' : 'destroy'}`, cardType, cardSize, 'click', payload, 'bigquery');

        toggleCollection(e, 'Gigs I Love', isFavorited, this.playAnimation);
    }

    playAnimation() {
        const turnOffAnimation = () => {
            this.setState({animation: false}, () => {
                this.heartIcon.removeEventListener('animationend', turnOffAnimation);
            });
        };

        this.setState({animation: true}, () => {
            this.heartIcon.addEventListener('animationend', turnOffAnimation);
        });
    }

    render() {
        const { isFavorited, user, cardType } = this.props,
            { animation } = this.state,
            heartColor = isFavorited ? ' red' : '',
            hintClassTrue = cardType === 'list' ? 'hint--bottom-right ' : 'hint--top ',
            hintClass = !isFavorited ? hintClassTrue : '',
            hintText = !isFavorited ? i18n.t('collections.add_to_favorites') : null,
            setHeartIconRef = (element) => {
                this.heartIcon = element;
            };

        return (
            <a className={`${hintClass}${animation ? 'is-animated ' : ''}icn-heart${user ? '' : ' js-open-popup-join'}`}
                href="#!"
                {...(hintText && {'data-hint': hintText})}
                data-gtm-action="hp-clicked-heart"
                data-gtm-event="collections"
                onClick={this.onClick}>
                <i className={`ficon ficon-favorite${heartColor}`} ref={setHeartIconRef}></i>
            </a>
        );
    }
}

Favorite.propTypes = {
    isFavorited: PropTypes.bool,
    cardType: PropTypes.string,
    user: PropTypes.object,
    toggleCollection: PropTypes.func
};

export default Favorite;



// WEBPACK FOOTER //
// ./src/shared/collect_gig/favorite/index.js